'use client';

import { useCallback } from 'react';

import { type ToastOptions, useToasts } from '@air/provider-toast';

import { truncateToastMessage } from '~/utils/formatSyncHostError';

const ERROR_TOAST_OPTIONS = {
  color: 'red',
  timeBeforeAutoDismiss: null,
  type: 'assertive',
  withCloseButton: true,
} satisfies ToastOptions;

/**
 * Premiere panel toasts — error toasts are dismissible and truncated so long
 * UXP host messages don't cover the review UI.
 */
export const usePremiereToasts = () => {
  const toasts = useToasts();

  const showErrorToast = useCallback(
    (message: string, options?: ToastOptions) => {
      toasts.showToast(truncateToastMessage(message), {
        ...ERROR_TOAST_OPTIONS,
        ...options,
      });
    },
    [toasts],
  );

  return {
    ...toasts,
    showErrorToast,
  };
};
